import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import TextRevealOnScroll from '../components/utils/TextRevealOnScroll';

const blogPosts = [
    { title: "Writing crisp interface copy that drives activation", slug: "interface-copy", tag: "Design", date: "10/24/25", imagePlaceholder: true },
    { title: "Designing fast feedback loops in AI-native products", slug: "feedback-loops", tag: "Product", date: "10/20/25", imagePlaceholder: true },
    { title: "Navigating EU/GCC regulatory pathways for healthcare AI", slug: "regulatory-pathways", tag: "GTM", date: "10/15/25", imagePlaceholder: true },
    // --- ADDED: Amama Bypass topic ---
    { title: "The strategic use of non-dilutive capital (Amama Bypass) vs. equity funding", slug: "capital-strategy", tag: "Finance", date: "10/10/25", imagePlaceholder: true },
    // Add more posts here
];

const Insights = () => {
    const introText = "Tactical essays and playbooks on AI product design, market entry, and enterprise readiness—practical, testable, and data-backed.";

    return (
        <motion.div
            className="bg-background py-12 md:py-16"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
        >
            <div className="container mx-auto px-6">

                <div className="max-w-6xl mx-auto mb-16">
                    <motion.h1
                        className="text-4xl md:text-5xl font-bold text-foreground mb-6 font-serif"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, delay: 0.2 }}
                    >
                        Insights
                    </motion.h1>

                    <div className="text-lg md:text-xl text-muted-foreground max-w-3xl">
                        <TextRevealOnScroll text={introText} />
                    </div>
                </div>


                {/* Blog Post List */}
                <div className="mt-16 space-y-12 border-t border-border pt-12 max-w-6xl mx-auto">
                    {blogPosts.map((post, index) => (
                        <motion.div
                            key={post.slug}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 + 0.3 }}
                            viewport={{ once: true, amount: 0.2 }}
                            whileHover={{ y: -5, transition: { duration: 0.2 } }}
                        >
                            <Link
                                to={`/insights/${post.slug}`}
                                className="block group p-4 rounded-lg transition-all duration-300 border border-transparent hover:border-border hover:bg-card/50"
                            >
                                <div className="flex flex-col sm:flex-row gap-6 md:gap-8 items-start">

                                    {post.imagePlaceholder && (
                                        <div className="w-full sm:w-48 md:w-64 h-32 sm:h-auto sm:aspect-[4/3] bg-muted rounded-lg flex-shrink-0 overflow-hidden">
                                            <div className="w-full h-full bg-muted group-hover:scale-105 transition-transform duration-300"></div>
                                        </div>
                                    )}

                                    <div className="flex-grow">
                                        {/* --- UPDATED: Title hover uses gradient text --- */}
                                        <h2 className="text-xl md:text-2xl font-bold text-foreground group-hover:bg-gradient-to-r group-hover:from-blue-500 group-hover:to-cyan-500 group-hover:bg-clip-text group-hover:text-transparent transition-colors duration-300 mb-2">
                                            {post.title}
                                        </h2>
                                        <div className="flex items-center gap-4 text-sm text-muted-foreground mt-2">
                                            <span className="inline-block bg-muted px-3 py-1 rounded text-xs font-medium uppercase tracking-wider">
                                                {post.tag}
                                            </span>
                                            <span>{post.date}</span>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </motion.div>
                    ))}
                </div>
            </div>
        </motion.div>
    );
};

export default Insights;